import { useEffect } from 'react';

export function usePageTitle(title: string) {
  useEffect(() => {
    if (typeof document !== 'undefined' && title) {
      document.title = title;
    }
  }, [title]);
}


